import React from 'react'
import { useIntl } from 'react-intl'
import { Box, useTheme } from '@mui/material'
import { QuestionState } from '../../../../features/types'

interface Props {
    questions: QuestionState[]
}

const ResultNavigation: React.FC<Props> = ({ questions = [] }) => {
    const theme = useTheme()
    const { formatMessage } = useIntl()

    const styles = {
        wrapper: {
            border: `1px solid ${theme.palette.grey[200]}`,
            mb: 2,
            p: 2,
            borderRadius: '8px',
        },
        answered: {
            mb: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontWeight: 500,
        },
        questions: {
            display: 'grid',
            gridTemplateColumns: 'repeat(5, auto)',
            alignItems: 'start',
            justifyContent: 'space-between',
            gap: '8px',
        },
        question: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',

            width: '40px',
            height: '40px',

            borderRadius: '4px',
            background: theme.palette.grey[100],
            cursor: 'pointer',

            '&:hover': {
                background: theme.palette.grey[200],
            },
        },
    }
    return (
        <Box sx={styles.wrapper}>
            <Box sx={styles.answered}>
                {formatMessage({ id: 'questions' })}
                {/* {formatMessage({ id: 'answeredQuestions' })}:<Box>4</Box> */}
            </Box>

            <Box sx={styles.questions}>
                {questions.map((item, index) => (
                    <Box
                        key={index}
                        sx={styles.question}
                    >
                        {index + 1}
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

export default ResultNavigation
